<template lang="html">
  <div class="main-body">
    <div class="main-body-search">
      <el-form :inline="true" :model="filters" @submit.native.prevent>
        <el-form-item>
          <el-input
            v-model="filters.fuzzyText"
            prefix-icon="el-icon-search"
            placeholder="角色名称或描述"
            @keyup.enter.native="getList(1)"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="getList(1)"
            >查询</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-plus"
            @click="showForm(0, false, {})"
            >新增</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div class="main-body-table">
      <!--列表-->
      <el-table :data="tableData" style="width: 100%">
        <el-table-column type="index" width="60"> </el-table-column>
        <el-table-column prop="roleName" label="角色名称" width="200">
        </el-table-column>
        <el-table-column prop="detail" label="角色描述"> </el-table-column>
        <el-table-column prop="appName" label="所属应用" width="220">
        </el-table-column>
        <el-table-column label="操作" width="220">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.action == '' || scope.row.action == null"
              size="small"
              @click="showForm(1, scope.row)"
              >编辑</el-button
            >
            <el-button
              v-if="scope.row.action == '' || scope.row.action == null"
              type="danger"
              size="small"
              @click="handleDel(scope.$index, scope.row)"
              >删除</el-button
            >
            <el-button size="small" type="info" @click="showForm(2, scope.row)"
              >查看</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!--工具条-->
      <el-pagination
        class="main-body-table-page"
        layout="total, prev, pager, next, jumper"
        @current-change="handleCurrentChange"
        :current-page="page.current"
        :page-size="page.size"
        :total="page.total"
      >
      </el-pagination>
    </div>
    <!--新增/修改界面-->
    <el-dialog
      v-dialogDrag
      ref="roledialog"
      :title="formLable[handleType]"
      :visible.sync="roleFormVisible"
      @close="closeDialog"
      :close-on-click-modal="false"
    >
      <el-form
        :model="roleForm"
        label-width="80px"
        :rules="roleFormRules"
        ref="roleForm"
      >
        <el-form-item label="角色名称" prop="roleName">
          <el-input v-model="roleForm.roleName" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="所属应用" prop="appId">
          <el-select
            v-model="roleForm.appId"
            filterable
            placeholder="请选择"
            @change="changeAppSelect"
          >
            <el-option
              v-for="item in appList"
              :key="item.id"
              :label="item.appFullName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="角色描述" prop="detail">
          <el-input
            v-model="roleForm.detail"
            type="textarea"
            :rows="4"
            placeholder="请输入内容"
            auto-complete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <el-card style="height:300px; overflow-y:scroll;">
        <div slot="header" class="clearfix">
          <span>操作权限列表</span>
        </div>
        <div>
          <div class="expand">
            <div>
              <el-tree
                ref="tree"
                class="expand-tree"
                :data="treeData"
                node-key="id"
                :render-after-expand="false"
                highlight-current
                default-expand-all
                show-checkbox
                :props="Props"
                :expand-on-click-node="false"
                :default-checked-keys="defaultCheckedKeys"
              >
              </el-tree>
            </div>
          </div>
        </div>
      </el-card>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="closeDialog">关闭</el-button>
        <el-button
          v-if="handleType !== 2"
          type="primary"
          @click="handleSave"
          :loading="formLoading"
          >保存</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getRoles, getMenus, insertRoleAprv, updateRole, deleteRole } from '../../api/sum/Role'
import { getMenuTree } from '../../api/sum/Menu'
export default {
  data() {
    return {
      // 菜单树控件的数据
      treeData: [],
      Props: {
        children: 'children',
        label: 'menuName'
      },
      // 查询条件
      filters: {
        fuzzyText: ''
      },
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      roleForm: {},
      roleFormRules: {
        roleName: [
          { required: true, message: '请输入角色名称', trigger: 'blur' }
        ],
        appId: [{ required: true, message: '请选择所属应用', trigger: 'blur' }]
      },
      formLoading: false,
      roleFormVisible: false,
      defaultCheckedKeys: [],
      // 操作类型，0新增, 1修改 2查看
      handleType: 0,
      formLable: ['新增', '修改', '查看'],
      tableData: [],
      appList: [] // 应用列表
    }
  },
  mounted() {
    // 加载
    this.loadApplication()
    // 默认查询
    this.getList()
  },
  methods: {
    closeDialog() {
      // this.$refs.tree.resetChecked()
      this.roleForm = {}
      this.roleFormVisible = false
      this.treeData = []
    },
    handleCurrentChange(val) {
      this.page.current = val
      this.getList()
    },
    changeAppSelect(selVal) {
      this.treeData = []
      let params = { appId: selVal }
      getMenuTree(params).then(res => {
        this.treeData = res.data
        this.defaultCheckedKeys = []
      })
    },
    // 查询
    getList(first) {
      if (first === 1) {
        this.filters.current = 1
        this.filters.size = 10
      } else {
        this.filters.current = this.page.current
        this.filters.size = this.page.size
      }
      getRoles(this.filters)
        .then(response => {
          this.tableData = response.data
          this.page.total = response.total
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 加载应用信息
    loadApplication() {
      this.$http
        .post('/app/selectList')
        .then(res => {
          let { code, data } = res
          if (code === 20000) {
            this.appList = data
          }
        })
        .catch(rej => {
          console.log(rej)
        })
    },

    // 保存
    handleSave() {
      if (this.handleType === 0) {
        // 新增
        this.handleAdd()
      } else {
        // 修改
        this.handleUpdate()
      }
    },
    // 新增
    handleAdd() {
      this.$refs.roleForm.validate(valid => {
        if (valid) {
          this.formLoading = true
          var str = this.$refs.tree.getCheckedKeys();
          this.roleForm.menuIds = str.join(',');
          this.roleForm.action = 1;
          insertRoleAprv(this.roleForm).then(() => {
            this.formLoading = false
            this.closeDialog()
            this.$message({
              message: '新增成功',
              type: 'success'
            })
            this.getList()
          })
        }
      })
    },
    // 修改
    handleUpdate() {
      this.$refs.roleForm.validate(valid => {
        if (valid) {
          this.formLoading = true
          var str = this.$refs.tree
            .getCheckedNodes(false, true)
            .map(node => node.id);
          this.roleForm.menuIds = str.join(',');
          updateRole(this.roleForm).then(() => {
            this.formLoading = false
            this.closeDialog()
            this.$message({
              message: '修改成功',
              type: 'success'
            })
            this.getList()
          })
        }
      })
    },
    // 删除
    handleDel(index, row) {
      this.$confirm('确认删除该记录吗?', '提示', {
        type: 'warning'
      })
        .then(() => {
          deleteRole({id: row.id}).then(() => {
            this.$message({
              message: '删除成功',
              type: 'success'
            })
            this.getList()
          })
        })
        .catch(() => {})
    },
    /**
     * 显示表单
     * @param {Integer} type 处理类型
     * @param {Object} row 行记录
     */
    showForm(type, row) {
      this.roleFormVisible = true
      this.$nextTick(() => {
        this.$refs.roleForm.clearValidate()
      })
      this.handleType = type
      this.roleForm = Object.assign(this.roleForm, row)
      if (this.handleType === 1 || this.handleType === 2) {
        let params = { appId: row.appId, roleId: row.id }
        getMenus(params).then(res => {
          let { code, data } = res
          if (code === 20000) {
            this.treeData = data.menuTree
            this.defaultCheckedKeys = data.authorizedMenuIds
            this.roleFormVisible = true
          }
        })
      }
    }
  }
}
</script>

<style lang="scss"></style>
